const escapeHtml = (text) => {
  if (!text) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

const getItemClassName = (itemType) => {
  switch (itemType) {
    case 'COMBO':
      return 'veg-item combo-item';
    case 'BABY_FOOD':
      return 'veg-item baby-item';
    case 'FREE_GIFT':
      return 'veg-item free-item';
    default:
      return 'veg-item';
  }
};

const MENU_CSS = `
  :root {
    --green-deep: #1a5c2a;
    --green-primary: #2d7a3f;
    --green-medium: #3d9950;
    --green-light: #5cb870;
    --green-pale: #e8f5e9;
    --green-mist: #f0f9f1;
    --cream: #fdfcf7;
    --orange-accent: #e8833a;
    --text-dark: #1a2e1a;
    --text-body: #2c3e2c;
    --text-muted: #5a6e5a;
    --white: #ffffff;
    --shadow-soft: 0 2px 16px rgba(26,92,42,0.08);
    --shadow-card: 0 4px 24px rgba(26,92,42,0.10);
    --shadow-hover: 0 8px 32px rgba(26,92,42,0.16);
    --radius: 16px;
    --radius-sm: 10px;
  }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    font-family: 'Be Vietnam Pro', sans-serif;
    background: var(--cream);
    color: var(--text-body);
    line-height: 1.6;
    overflow-x: hidden;
  }
  .hero {
    background: linear-gradient(135deg, var(--green-deep) 0%, var(--green-primary) 40%, var(--green-medium) 100%);
    position: relative;
    padding: 40px 24px 60px;
    text-align: center;
    overflow: hidden;
  }
  .hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 15% 80%, rgba(255,255,255,0.06) 0%, transparent 50%),
      radial-gradient(circle at 85% 20%, rgba(255,255,255,0.08) 0%, transparent 40%);
    pointer-events: none;
  }
  .hero::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0; right: 0;
    height: 40px;
    background: var(--cream);
    clip-path: ellipse(55% 100% at 50% 100%);
  }
  .hero-leaf { position: absolute; font-size: 2rem; opacity: 0.15; animation: floatLeaf 8s ease-in-out infinite; }
  .hero-leaf:nth-child(1) { top: 12%; left: 6%; }
  .hero-leaf:nth-child(2) { top: 55%; right: 5%; animation-delay: 2s; font-size: 1.5rem; }
  .hero-leaf:nth-child(3) { top: 25%; right: 12%; animation-delay: 4s; font-size: 2.5rem; }
  .hero-leaf:nth-child(4) { bottom: 30%; left: 12%; animation-delay: 1s; font-size: 1.8rem; }
  @keyframes floatLeaf { 0%,100%{transform:translateY(0) rotate(0)} 50%{transform:translateY(-12px) rotate(8deg)} }
  .brand-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(255,255,255,0.15);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50px;
    padding: 8px 20px;
    margin-bottom: 16px;
    animation: fadeDown 0.6s ease-out;
  }
  .brand-badge span { color: white; font-size: 0.85rem; font-weight: 500; letter-spacing: 1.5px; text-transform: uppercase; }
  .hero h1 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(1.8rem, 4.5vw, 2.6rem);
    font-weight: 800;
    color: white;
    margin-bottom: 8px;
    animation: fadeDown 0.7s ease-out 0.1s both;
    text-shadow: 0 2px 12px rgba(0,0,0,0.15);
  }
  .hero-sub {
    color: rgba(255,255,255,0.85);
    font-size: 1rem;
    font-weight: 300;
    max-width: 560px;
    margin: 0 auto;
    animation: fadeDown 0.7s ease-out 0.2s both;
  }
  .customer-info {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    justify-content: center;
    margin-top: 18px;
    animation: fadeDown 0.7s ease-out 0.3s both;
  }
  .info-chip {
    background: rgba(255,255,255,0.13);
    backdrop-filter: blur(6px);
    border: 1px solid rgba(255,255,255,0.18);
    border-radius: 30px;
    padding: 6px 16px;
    color: white;
    font-size: 0.82rem;
    font-weight: 400;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .info-chip .chip-icon { font-size: 0.95rem; }
  @keyframes fadeDown { from{opacity:0;transform:translateY(-16px)} to{opacity:1;transform:translateY(0)} }
  .summary-strip {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 14px;
    max-width: 820px;
    margin: -30px auto 36px;
    padding: 0 24px;
    position: relative;
    z-index: 2;
  }
  .stat-card {
    background: var(--white);
    border-radius: var(--radius);
    padding: 18px 14px;
    text-align: center;
    box-shadow: var(--shadow-card);
    border: 1px solid rgba(45,122,63,0.08);
    animation: popUp 0.5s ease-out both;
  }
  @keyframes popUp { from{opacity:0;transform:translateY(20px) scale(.95)} to{opacity:1;transform:translateY(0) scale(1)} }
  .stat-icon { font-size: 1.5rem; margin-bottom: 4px; }
  .stat-value { font-family:'Playfair Display',serif; font-size:1.4rem; font-weight:700; color:var(--green-deep); }
  .stat-label { font-size:0.75rem; color:var(--text-muted); font-weight:500; margin-top:2px; }
  .container { max-width: 900px; margin: 0 auto; padding: 0 24px 60px; }
  .week-section { margin-bottom: 40px; }
  .week-header { display:flex; align-items:center; gap:14px; margin-bottom:20px; }
  .week-number {
    width:48px; height:48px;
    background: linear-gradient(135deg, var(--green-primary), var(--green-light));
    border-radius:14px;
    display:flex; align-items:center; justify-content:center;
    font-family:'Playfair Display',serif; font-size:1.3rem; font-weight:700; color:white;
    flex-shrink:0;
    box-shadow: 0 4px 12px rgba(45,122,63,0.25);
  }
  .week-title { font-family:'Playfair Display',serif; font-size:1.3rem; font-weight:700; color:var(--green-deep); }
  .week-title small { display:block; font-family:'Be Vietnam Pro',sans-serif; font-size:0.78rem; font-weight:400; color:var(--text-muted); margin-top:2px; }
  .deliveries { display:grid; grid-template-columns:repeat(auto-fit, minmax(340px, 1fr)); gap:18px; }
  .delivery-card {
    background: var(--white);
    border-radius: var(--radius);
    overflow: hidden;
    box-shadow: var(--shadow-soft);
    border: 1px solid rgba(45,122,63,0.06);
    transition: all 0.3s ease;
  }
  .delivery-card:hover { box-shadow: var(--shadow-hover); transform: translateY(-3px); }
  .card-header {
    display:flex; align-items:center; justify-content:space-between;
    padding:14px 20px;
    background: linear-gradient(135deg, var(--green-pale), var(--green-mist));
    border-bottom: 1px solid rgba(45,122,63,0.08);
  }
  .card-header-left { display:flex; align-items:center; gap:10px; }
  .delivery-dot { width:10px; height:10px; background:var(--green-medium); border-radius:50%; box-shadow:0 0 0 3px rgba(61,153,80,0.2); }
  .card-day { font-weight:600; font-size:0.93rem; color:var(--green-deep); }
  .card-weight {
    background: var(--green-primary);
    color: white;
    font-size: 0.73rem;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 20px;
    letter-spacing: 0.5px;
  }
  .card-body { padding: 4px 12px 12px; }
  .veg-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-radius: var(--radius-sm);
    transition: background 0.2s ease;
    gap: 8px;
  }
  .veg-item:hover { background: var(--green-mist); }
  .veg-item + .veg-item { border-top: 1px dashed rgba(45,122,63,0.1); }
  .veg-name { display:flex; align-items:center; gap:10px; font-weight:500; font-size:0.9rem; color:var(--text-dark); flex:1; min-width:0; }
  .veg-emoji { font-size:1.15rem; width:26px; text-align:center; flex-shrink:0; }
  .veg-name-text { flex:1; min-width:0; }
  .veg-detail { display:block; font-size:0.76rem; color:var(--text-muted); font-weight:400; font-style:italic; margin-top:1px; }
  .veg-weight {
    font-size:0.8rem; font-weight:600; color:var(--green-primary);
    background:var(--green-pale); padding:4px 10px; border-radius:8px; white-space:nowrap; flex-shrink:0;
    display:flex; align-items:center; gap:2px;
  }
  .veg-qty { font-weight:700; }
  .veg-converted { font-weight:500; color:var(--text-muted); font-size:0.75rem; }
  .veg-item.free-item { background: linear-gradient(135deg, #fff8e1, #fff3e0); border: 1px dashed #ffa726; }
  .veg-item.free-item .veg-weight { background:#fff3e0; color:#e65100; }
  .veg-item.combo-item { background: linear-gradient(135deg, #f3e5f5, #ede7f6); border-left: 3px solid #9c27b0; }
  .veg-item.combo-item .veg-weight { background:#f3e5f5; color:#7b1fa2; }
  .veg-item.baby-item { background: linear-gradient(135deg, #e3f2fd, #e1f5fe); border-left: 3px solid #2196f3; }
  .veg-item.baby-item .veg-weight { background:#e3f2fd; color:#1565c0; }
  .notes-section {
    background: linear-gradient(135deg, var(--green-pale), rgba(232,245,233,0.4));
    border: 1px solid rgba(45,122,63,0.12);
    border-radius: var(--radius);
    padding: 28px;
    margin-top: 10px;
  }
  .notes-title { font-family:'Playfair Display',serif; font-size:1.15rem; font-weight:700; color:var(--green-deep); margin-bottom:14px; display:flex; align-items:center; gap:8px; }
  .note-item { display:flex; align-items:flex-start; gap:10px; margin-bottom:10px; font-size:0.9rem; color:var(--text-body); line-height:1.6; }
  .note-bullet { flex-shrink:0; width:6px; height:6px; border-radius:50%; background:var(--green-medium); margin-top:8px; }
  .footer {
    text-align: center;
    padding: 32px 24px 40px;
    background: linear-gradient(135deg, var(--green-deep), var(--green-primary));
    color: rgba(255,255,255,0.8);
    font-size: 0.85rem;
    position: relative;
  }
  .footer::before { content:''; position:absolute; top:-2px; left:0; right:0; height:40px; background:var(--cream); clip-path:ellipse(55% 100% at 50% 0%); }
  .footer-brand { font-family:'Playfair Display',serif; font-size:1.3rem; font-weight:700; color:white; margin-bottom:6px; }
  .progress-section { margin-bottom: 36px; }
  .progress-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:10px; }
  .progress-label { font-weight:600; font-size:0.9rem; color:var(--green-deep); }
  .progress-value { font-family:'Playfair Display',serif; font-weight:700; color:var(--green-primary); }
  .progress-track { height:10px; background:var(--green-pale); border-radius:10px; overflow:hidden; }
  .progress-fill { height:100%; background:linear-gradient(90deg,var(--green-primary),var(--green-light)); border-radius:10px; animation:fillBar 1.5s ease-out 0.5s both; }
  @keyframes fillBar { from{width:0} }
  .week-marks { display:flex; justify-content:space-between; margin-top:6px; padding:0 2px; }
  .week-marks span { font-size:0.7rem; color:var(--text-muted); font-weight:500; }
  @media (max-width:600px) {
    .deliveries { grid-template-columns:1fr; }
    .summary-strip { grid-template-columns:repeat(2,1fr); margin-top:-28px; }
    .hero { padding:32px 20px 48px; }
    .container { padding:0 16px 40px; }
    .notes-section { padding:20px; }
    .customer-info { flex-direction:column; align-items:center; }
  }
`;

const generateItemWeightHtml = (item) => {
  if (item.quantity) {
    const converted = Math.round((item.quantity / (item.convert_rate || 1)) * 100) / 100;
    if (item.convert_rate && item.convert_rate !== 1) {
      return `<span class="veg-qty">${item.quantity}</span><span class="veg-converted"> → ${converted}kg</span>`;
    }
    return `<span class="veg-qty">${item.quantity}</span><span class="veg-converted">kg</span>`;
  }
  return escapeHtml(item.weight_text);
};

const generateItemHtml = (item) => {
  const className = getItemClassName(item.item_type);
  const detailHtml = item.detail ? `<span class="veg-detail">${escapeHtml(item.detail)}</span>` : '';
  const weightHtml = generateItemWeightHtml(item);

  return `          <div class="${className}">
            <span class="veg-name"><span class="veg-emoji">${item.emoji || ''}</span><span class="veg-name-text">${escapeHtml(item.name)}${detailHtml}</span></span>
            <span class="veg-weight">${weightHtml}</span>
          </div>`;
};

const generateDeliveryHtml = (delivery) => {
  const weight = (delivery.items || []).reduce((sum, item) => {
    if (item.item_type === 'FREE_GIFT') return sum;
    if (item.quantity && item.convert_rate) return sum + (item.quantity / item.convert_rate);
    if (item.weight_value) return sum + parseFloat(item.weight_value);
    return sum;
  }, 0);

  const itemsHtml = (delivery.items || []).map(generateItemHtml).join('\n');

  return `      <div class="delivery-card">
        <div class="card-header">
          <div class="card-header-left">
            <div class="delivery-dot"></div>
            <span class="card-day">${escapeHtml(delivery.label || `Lần ${delivery.delivery_number}`)}</span>
          </div>
          <span class="card-weight">${Math.round(weight * 100) / 100} KG</span>
        </div>
        <div class="card-body">
${itemsHtml}
        </div>
      </div>`;
};

const generateWeekHtml = (week, deliveryDays) => {
  const deliveriesHtml = (week.deliveries || []).map(generateDeliveryHtml).join('\n\n');

  return `  <section class="week-section">
    <div class="week-header">
      <div class="week-number">${week.week_number}</div>
      <div class="week-title">${escapeHtml(week.label || `Tuần ${week.week_number}`)} <small>Giao ${escapeHtml(deliveryDays || '')}</small></div>
    </div>
    <div class="deliveries">
${deliveriesHtml}
    </div>
  </section>`;
};

export const generateMenuHtml = (menuData) => {
  const babyFoodSets = (menuData.weeks || []).reduce((count, week) =>
    count + (week.deliveries || []).reduce((c, d) =>
      c + (d.items || []).filter(i => i.item_type === 'BABY_FOOD').length, 0), 0);
  const totalDeliveries = (menuData.weeks || []).reduce((sum, w) => sum + (w.deliveries || []).length, 0);

  const weeksHtml = (menuData.weeks || []).map(w => generateWeekHtml(w, menuData.delivery_days)).join('\n\n');

  const notesHtml = (menuData.notes || []).map(note => `    <div class="note-item">
      <div class="note-bullet"></div>
      <span>${note}</span>
    </div>`).join('\n');

  const weekMarksHtml = (menuData.weeks || []).map(w => `      <span>${escapeHtml(w.label || `Tuần ${w.week_number}`)}</span>`).join('');

  const babyFoodStatHtml = babyFoodSets > 0 ? `  <div class="stat-card">
    <div class="stat-icon">👶</div>
    <div class="stat-value">${babyFoodSets} set</div>
    <div class="stat-label">Set ăn dặm bé</div>
  </div>` : '';

  return `<!DOCTYPE html>
<html lang="vi">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Mây's Farm - Menu Rau KH ${escapeHtml(menuData.customer_name)}</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=Be+Vietnam+Pro:wght@300;400;500;600;700&display=swap" rel="stylesheet">
<style>
${MENU_CSS}
</style>
</head>
<body>

<header class="hero">
  <div class="hero-leaf">🌿</div>
  <div class="hero-leaf">🍃</div>
  <div class="hero-leaf">🌱</div>
  <div class="hero-leaf">☘️</div>

  <div class="brand-badge">
    <span>🌿 Tiệm Mây's Farm</span>
  </div>
  <h1>${escapeHtml(menuData.title || 'Menu Rau')}</h1>
  <p class="hero-sub">${escapeHtml(menuData.subtitle || '')}</p>

  <div class="customer-info">
    <span class="info-chip"><span class="chip-icon">👤</span> ${escapeHtml(menuData.customer_name)}</span>
    ${menuData.customer_address ? `<span class="info-chip"><span class="chip-icon">🏠</span> ${escapeHtml(menuData.customer_address)}</span>` : ''}
    ${menuData.delivery_days ? `<span class="info-chip"><span class="chip-icon">📅</span> Giao ${escapeHtml(menuData.delivery_days)}</span>` : ''}
    <span class="info-chip"><span class="chip-icon">📦</span> ${menuData.total_weight}kg (${menuData.package_weight} + ${menuData.bonus_weight} tặng)</span>
  </div>
</header>

<div class="summary-strip">
  <div class="stat-card">
    <div class="stat-icon">📦</div>
    <div class="stat-value">${menuData.total_weight}kg</div>
    <div class="stat-label">Tổng cả tháng</div>
  </div>
  <div class="stat-card">
    <div class="stat-icon">📅</div>
    <div class="stat-value">${totalDeliveries} lần</div>
    <div class="stat-label">Tổng lượt giao</div>
  </div>
  <div class="stat-card">
    <div class="stat-icon">🎁</div>
    <div class="stat-value">+${menuData.bonus_weight}kg</div>
    <div class="stat-label">Rau tặng kèm</div>
  </div>
  <div class="stat-card">
    <div class="stat-icon">🗓️</div>
    <div class="stat-value">${escapeHtml(menuData.delivery_days || '')}</div>
    <div class="stat-label">Lịch giao hàng</div>
  </div>
${babyFoodStatHtml}
</div>

<main class="container">

  <div class="progress-section">
    <div class="progress-header">
      <span class="progress-label">Tiến trình giao hàng</span>
      <span class="progress-value">${menuData.total_weight}/${menuData.total_weight} kg</span>
    </div>
    <div class="progress-track">
      <div class="progress-fill" style="width:100%"></div>
    </div>
    <div class="week-marks">
${weekMarksHtml}
    </div>
  </div>

${weeksHtml}

  ${notesHtml ? `<div class="notes-section">
    <div class="notes-title">📋 Lưu ý</div>
${notesHtml}
  </div>` : ''}

</main>

<footer class="footer">
  <div class="footer-brand">🌿 Mây's Farm</div>
  <p>Tươi xanh từ vườn — Giao tận tay mỗi tuần</p>
  <p style="margin-top:4px; opacity:0.6; font-size:0.78rem;">Menu rau KH ${escapeHtml(menuData.customer_name)} • ${escapeHtml(menuData.customer_address || '')} • Gói ${menuData.package_weight}kg + ${menuData.bonus_weight}kg tặng</p>
</footer>

</body>
</html>`;
};

export const downloadMenuHtml = (menuData) => {
  const html = generateMenuHtml(menuData);
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  const fileName = `MayFarm-Menu-${(menuData.customer_name || 'Menu').replace(/\s+/g, '-')}.html`;
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
